import { render, staticRenderFns } from "./reservation.vue?vue&type=template&id=722d6a82&scoped=true"
import script from "./reservation.vue?vue&type=script&lang=ts"
export * from "./reservation.vue?vue&type=script&lang=ts"
import style0 from "./reservation.vue?vue&type=style&index=0&id=722d6a82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722d6a82",
  null
  
)

export default component.exports